<div *ngIf="showLoader" [ngClass]="{
    'loader-no-whats-new': !showWhatsNewContainer,
    'loader-withscroll': showWhatsNewContainer && whatsNewHasScrollbar,
    'loader-withoutscroll': showWhatsNewContainer && !whatsNewHasScrollbar
}">
  <b> {{'Trying to retrieve FDRS Connection'|translate}}.......</b>
  <div><img src="assets/images/ajax-loader.gif" alt="Loading" width="100" height="100"></div>
</div>


<ng-container *ngIf="!isFDRSWebSoecketConnected && !showLoader">
  <div [ngClass]="{
      'fdrs-status-no-whats-new': !showWhatsNewContainer,
      'fdrs-status-withscroll': showWhatsNewContainer && whatsNewHasScrollbar,
      'fdrs-status-withoutscroll': showWhatsNewContainer && !whatsNewHasScrollbar
  }">
    <label [ngClass]="{
        'socketStatus-no-whats-new': !showWhatsNewContainer,
        'socketStatus-withscroll': showWhatsNewContainer && whatsNewHasScrollbar,
        'socketStatus-withoutscroll': showWhatsNewContainer && !whatsNewHasScrollbar
    }" id="nwHeader">{{'Ford Diagnosis and Repair System not running 1'|translate}}. {{'Please
      start the application on your computer and click on'|translate}}</label><span [ngClass]="{
        'retryFDRSLink-no-whats-new': !showWhatsNewContainer,
        'retryFDRSLink-withscroll': showWhatsNewContainer && whatsNewHasScrollbar,
        'retryFDRSLink': showWhatsNewContainer && !whatsNewHasScrollbar
    }" (click)="retryFDRSConnection();">{{'retry'|translate}}</span>
  </div>
</ng-container>



<ng-container *ngIf="isFDRSWebSoecketConnected && !showLoader">
  <ng-container *ngIf="!isDisableNwHeader">
    <label [ngClass]="{
        'header-no-whats-new': !showWhatsNewContainer,
        'header-margin-networktest-hasscroll': showWhatsNewContainer && whatsNewHasScrollbar,
        'header-margin-networktest-noscroll': showWhatsNewContainer && !whatsNewHasScrollbar
    }" id="nwHeader">{{'Network Test'|translate}} </label>
  </ng-container>
</ng-container>


<ng-container *ngIf="isNetworkTestNeeded && !showLoader">
  <ng-container *ngIf="isFDRSWebSoecketConnected">
    <ng-container *ngIf="isShowOverrideBlock">
      <div [ngClass]="{
          'start-container-no-whats-new': !showWhatsNewContainer,
          'start-container-withscroll': showWhatsNewContainer && whatsNewHasScrollbar,
          'start-container-withoutscroll': showWhatsNewContainer && !whatsNewHasScrollbar
      }">
        <div class="top-section-row">
          <span class="info-icon"><i class="fa fa-info-circle"></i></span>
          <span class="image"></span>
          <label class="lblHeader">{{'Start Here'|translate}}</label>
        </div>
        <label class="lbl-text">{{'network test text1'|translate}}
          <a>{{'click here'|translate}}.</a>
        </label>
        <label class="lbl-text2">{{'Click the start button to continue'|translate}}</label>
        <div class="start-override-buttons-wrapper">
          <button class="btn-start startBtn-info" [attr.aria-label]='info' (click)="startNetworkTest()">{{'Start'|translate}}</button>
          <button class="btn-override" (click)="overrideBtnClicked()">{{'Override'|translate}}</button>
        </div>
        <div class="checkbox-row" *ngIf="isShowDataCollectorCheckBox">
              <span>
                <input type="checkbox" [checked]="isDataCollectorChecked" class="datacollectorCheckbox" [(ngModel)]="isDataCollectorChecked"
                       (change)="getDataCollectorCheckboxStatus(isDataCollectorChecked?'FULL':'SKIP_SPECIFIC')" />
                <span [ngClass]="{
                    'font-size-no-whats-new': !showWhatsNewContainer,
                    'font-size-11px': showWhatsNewContainer && whatsNewHasScrollbar,
                    'font-size-14px': showWhatsNewContainer && !whatsNewHasScrollbar
                }">&nbsp;&nbsp;{{'DC_NWT_Info'|translate}}</span>
            </span>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-container *ngIf="isNetworkTestNeeded && !showLoader">
  <ng-container *ngIf="isFDRSWebSoecketConnected">
    <ng-container *ngIf="isShowTestProgressBlock">
      <div [ngClass]="{
          'network-container-no-whats-new': !showWhatsNewContainer,
          'network-container-withscroll': showWhatsNewContainer && whatsNewHasScrollbar,
          'network-container-withoutscroll': showWhatsNewContainer && !whatsNewHasScrollbar
      }">
        <span><i class="fa fa-info-circle" [ngClass]="{
            'font-size-no-whats-new': !showWhatsNewContainer,
            'font-size-11px': showWhatsNewContainer && whatsNewHasScrollbar,
            'font-size-14px': showWhatsNewContainer && !whatsNewHasScrollbar
        }" style="color: gray !important; margin-left: 1%;"></i></span>
        <span><label class="network-test-header">{{'FDRS Network Test Progress'|translate}}</label></span>
        <div *ngIf="!progressbar && !isNetwork && !isNetworkTestError">
          <label class="network-status">{{'FDRS Network test Not Running'|translate}}</label>
        </div>
        <div *ngIf="progressbar && !isNetwork && !isNetworkFailure" class="progress">
          <div class="progress-bar progress-bar-striped s row_padding"></div>
        </div>
        <div *ngIf="progressbar && !isNetwork && !isNetworkFailure" [ngClass]="{
            'font-size-no-whats-new': !showWhatsNewContainer,
            'font-size-11px': showWhatsNewContainer && whatsNewHasScrollbar,
            'font-size-14px': showWhatsNewContainer && !whatsNewHasScrollbar
        }" style="margin-left: 3%;">
          {{'Performing Network Test'|translate}}..
        </div>
        <div *ngIf="isNetwork" [ngClass]="{
            'font-size-no-whats-new': !showWhatsNewContainer,
            'font-size-11px': showWhatsNewContainer && whatsNewHasScrollbar,
            'font-size-14px': showWhatsNewContainer && !whatsNewHasScrollbar
        }" style="margin-left: 3%;">
          {{'Network test is completed successfully'|translate}}.
        </div>
        <div *ngIf="isNetworkFailure" [ngClass]="{
            'font-size-no-whats-new': !showWhatsNewContainer,
            'font-size-11px': showWhatsNewContainer && whatsNewHasScrollbar,
            'font-size-14px': showWhatsNewContainer && !whatsNewHasScrollbar
        }" style="margin-left: 3%;">
          {{'Network test Fails to complete'|translate}}.
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

<ng-container *ngIf="isShowReRunBlock && !showLoader">
  <ng-container *ngIf="isFDRSWebSoecketConnected">
    <div [ngClass]="{
        'network-container-no-whats-new': !showWhatsNewContainer,
        'network-container-withscroll': showWhatsNewContainer && whatsNewHasScrollbar,
        'network-container-withoutscroll': showWhatsNewContainer && !whatsNewHasScrollbar
    }">
      <span><i class="fa fa-info-circle" [ngClass]="{
          'font-size-no-whats-new': !showWhatsNewContainer,
          'font-size-11px': showWhatsNewContainer && whatsNewHasScrollbar,
          'font-size-14px': showWhatsNewContainer && !whatsNewHasScrollbar
      }" style="color: gray !important; margin-left: 1%;"></i></span>
      <span><label class="network-test-header">{{'FDRS Network Test Progress'|translate}}</label></span>
      <label class="network-status">{{'Network Test Notifications'|translate}}.<a href="javascript:void(0);" class="link" [attr.aria-label]='info'
                                                                                  (click)="reRunNetworkTest()">{{'Re-run the network test'|translate}}</a></label>
      <div *ngIf="isShowDataCollectorCheckBox">
        <span>
          <input type="checkbox" [checked]="isDataCollectorChecked" class="datacollectorCheckbox" [(ngModel)]="isDataCollectorChecked"
                 (change)="getDataCollectorCheckboxStatus(isDataCollectorChecked?'FULL':'SKIP_SPECIFIC')" />
          <span [ngClass]="{
              'font-size-no-whats-new': !showWhatsNewContainer,
              'font-size-11px': showWhatsNewContainer && whatsNewHasScrollbar,
              'font-size-14px': showWhatsNewContainer && !whatsNewHasScrollbar
          }">&nbsp;&nbsp;{{'DC_NWT_Info'|translate}}</span>
        </span>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-container *ngIf="isNetworkTestError && !showLoader">
  <ng-container *ngIf="isFDRSWebSoecketConnected">
    <div [ngClass]="{
        'network-container-no-whats-new': !showWhatsNewContainer,
        'network-container-withscroll': showWhatsNewContainer && whatsNewHasScrollbar,
        'network-container-withoutscroll': showWhatsNewContainer && !whatsNewHasScrollbar
    }">
      <span><i class="fa fa-info-circle" [ngClass]="{
          'font-size-no-whats-new': !showWhatsNewContainer,
          'font-size-11px': showWhatsNewContainer && whatsNewHasScrollbar,
          'font-size-14px': showWhatsNewContainer && !whatsNewHasScrollbar
      }" style="color: gray !important; margin-left: 1%;"></i></span>
      <span><label class="network-test-header">{{'FDRS Network Test Progress'|translate}}</label></span>
      <div>
        <span>
          <label class="network-status">{{'FDRS Network Test Failed click to re run'|translate}}</label>
          <button class="btn-start" (click)="retryNetworkTest()">{{'RUN'|translate}}</button>
        </span>
      </div>
      <div *ngIf="isShowDataCollectorCheckBox">
        <span>
          <input type="checkbox" [checked]="isDataCollectorChecked" class="datacollectorCheckbox" [(ngModel)]="isDataCollectorChecked"
                 (change)="getDataCollectorCheckboxStatus(isDataCollectorChecked?'FULL':'SKIP_SPECIFIC')" />
          <span [ngClass]="{
              'font-size-no-whats-new': !showWhatsNewContainer,
              'font-size-11px': showWhatsNewContainer && whatsNewHasScrollbar,
              'font-size-14px': showWhatsNewContainer && !whatsNewHasScrollbar
          }">&nbsp;&nbsp;{{'DC_NWT_Info'|translate}}</span>
        </span>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-container *ngIf="isNWTestFailedMultiple && !showLoader">
  <ng-container *ngIf="isFDRSWebSoecketConnected">
    <div [ngClass]="{
        'network-container-no-whats-new': !showWhatsNewContainer,
        'network-container-withscroll': showWhatsNewContainer && whatsNewHasScrollbar,
        'network-container-withoutscroll': showWhatsNewContainer && !whatsNewHasScrollbar
    }">
      <span><i class="fa fa-info-circle" [ngClass]="{
          'font-size-no-whats-new': !showWhatsNewContainer,
          'font-size-11px': showWhatsNewContainer && whatsNewHasScrollbar,
          'font-size-14px': showWhatsNewContainer && !whatsNewHasScrollbar
      }" style="color: gray !important; margin-left: 1%;"></i></span>
      <span><label class="network-test-header">{{'FDRS Network Test Progress'|translate}}</label></span>
      <div>
        <span>
          <label class="network-status">{{'FDRS Network Test Failed multiple times continue with previous data retry or close'|translate}}?</label>
        </span>
        <span>
          <button class="btn-start-multiple" (click)="retryNetworkTest()">{{'RUN'|translate}}</button>
          <button class="btn-override-multiple" (click)="overrideBtnClicked()">{{'Override'|translate}}</button>
        </span>
      </div>
      <div *ngIf="isShowDataCollectorCheckBox">
        <span>
          <input type="checkbox" [checked]="isDataCollectorChecked" class="datacollectorCheckbox" [(ngModel)]="isDataCollectorChecked"
                 (change)="getDataCollectorCheckboxStatus(isDataCollectorChecked?'FULL':'SKIP_SPECIFIC')" />
          <span [ngClass]="{
              'font-size-no-whats-new': !showWhatsNewContainer,
              'font-size-11px': showWhatsNewContainer && whatsNewHasScrollbar,
              'font-size-14px': showWhatsNewContainer && !whatsNewHasScrollbar
          }">&nbsp;&nbsp;{{'DC_NWT_Info'|translate}}</span>
        </span>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-container *ngIf="isNWTestFailedAdmin && !showLoader">
  <ng-container *ngIf="isFDRSWebSoecketConnected">
    <div [ngClass]="{
        'network-container-no-whats-new': !showWhatsNewContainer,
        'network-container-withscroll': showWhatsNewContainer && whatsNewHasScrollbar,
        'network-container-withoutscroll': showWhatsNewContainer && !whatsNewHasScrollbar
    }">
      <span><i class="fa fa-info-circle" [ngClass]="{
          'font-size-no-whats-new': !showWhatsNewContainer,
          'font-size-11px': showWhatsNewContainer && whatsNewHasScrollbar,
          'font-size-14px': showWhatsNewContainer && !whatsNewHasScrollbar
      }" style="color: gray !important; margin-left: 1%;"></i></span>
      <span><label class="network-test-header">{{'FDRS Network Test Progress'|translate}}</label></span>
      <div>
        <span>
          <label class="network-status">{{'FDRS Network Test Failed continue with previous sdata retry or close'|translate}}?</label>
          <button class="btn-start-failure" (click)="retryNetworkTest()">{{'RUN'|translate}}</button>
          <button class="btn-override-failure"  style="margin-left:1% !important;" (click)="overrideBtnClicked()">{{'Override'|translate}}</button>
        </span>
      </div>
      <div *ngIf="isShowDataCollectorCheckBox">
        <span>
          <input type="checkbox" [checked]="isDataCollectorChecked" class="datacollectorCheckbox" [(ngModel)]="isDataCollectorChecked"
                 (change)="getDataCollectorCheckboxStatus(isDataCollectorChecked?'FULL':'SKIP_SPECIFIC')" />
          <span [ngClass]="{
              'font-size-no-whats-new': !showWhatsNewContainer,
              'font-size-11px': showWhatsNewContainer && whatsNewHasScrollbar,
              'font-size-14px': showWhatsNewContainer && !whatsNewHasScrollbar
          }">&nbsp;&nbsp;{{'DC_NWT_Info'|translate}}</span>
        </span>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #NWTInfo let-modal>
  <div class="container NWTContainer">
    <div class="row popup-header">
      <div class="pull-left">{{'Information'|translate}}</div>
      <div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
                                                            (click)="modal.dismiss('NWTInfo')"></i></div>
    </div>
    <div class="msg-body">
      <label>{{'An error occurred when running the application'|translate}}. {{'Cause'|translate}}: {{networkTestErrorMsg}}<br>
        {{'Close the message box and try again'|translate}}.{{'Network Test Message1'|translate}}.
      </label>
    </div>
    <hr class="hr-line">
    <div class="popup-footer">
      <button type="button" class="close-btn-popup pull-right" name="cancel"
              (click)="dismissNWTErrorPopUp()">{{'Continue'|translate | uppercase}}</button>
    </div>
  </div>
</ng-template>
<ng-template #DTCInfo let-modal>
  <div class="container NWTContainer">
    <div class="row popup-header">
      <div class="pull-left">{{'Information'|translate}}</div>
      <div class="pull-right cross-button" style="margin-top: -5.6%;" title="close"><i class="fa fa-times" aria-hidden="true"
                                                                                       (click)="modal.dismiss('DTCInfo')"></i></div>
    </div>
    <div class="msg-body">
      <label>{{'dtcClearInformation'|translate}}
      </label>
    </div>
    <hr class="hr-line">
    <div class="popup-footer">
      <button type="button" class="close-btn-popup pull-right" name="cancel"
              (click)="modal.dismiss('DTCInfo')">{{'CONTINUE'|translate}}</button>
    </div>
  </div>
</ng-template>
